export const camelToKebab = key =>
  String(key)
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase();

export const slugifyAnalysisName = value =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const slugifyProductItem = value =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/[\s_/]+/g, "-");

export const marketsRouteSync = {
  data() {
    return {
      isApplyingMarketsRoute: false
    };
  },
  watch: {
    $route(to) {
      if (to.params.productType !== this.marketsAsset) return;
      this.applyMarketsRoute(to);
    }
  },
  methods: {
    marketsMenu() {
      return this.view;
    },
    marketsRouteQuery() {
      return {};
    },
    applyMarketsQuery() {},
    onMarketsMenuLoaded() {
      if (this._isDestroyed || this._isBeingDestroyed) return;
      const productType = this.$route.params.productType;
      if (productType === this.marketsAsset) {
        this.applyMarketsRoute(this.$route);
      } else {
        this.syncMarketsRoute(!productType);
      }
    },
    analysisSlug(key) {
      const menu = this.marketsMenu() || {};
      const entry = menu[key];
      const label = entry && entry.name;
      return (label && slugifyAnalysisName(label)) || camelToKebab(key);
    },
    findAnalysisKeyBySlug(slug) {
      if (!slug) return null;
      const menu = this.marketsMenu() || {};
      const target = String(slug).toLowerCase();
      const keys = Object.keys(menu).filter(
        key => key !== "__typename" && menu[key]
      );
      return (
        keys.find(key => this.analysisSlug(key) === target) ||
        keys.find(key => camelToKebab(key) === target) ||
        null
      );
    },
    applyAnalysisKey(key) {
      const menu = this.marketsMenu();
      if (!menu || !menu[key]) return false;
      this.summarySelected = false;
      for (const k of Object.keys(menu)) {
        if (k === "__typename" || !menu[k]) continue;
        Object.assign(menu[k], { show: k === key });
      }
      return true;
    },
    marketsRouteItemFromRoute(route) {
      const { productItem, analysisType } = route.params;
      if (productItem) return productItem;
      if (
        analysisType &&
        !this.findAnalysisKeyBySlug(analysisType) &&
        this.marketsFindItem(analysisType) > -1
      ) {
        return analysisType;
      }
      return null;
    },
    async applyMarketsRoute(route) {
      this.isApplyingMarketsRoute = true;
      try {
        const itemSlug = this.marketsRouteItemFromRoute(route);
        if (itemSlug) await this.applyMarketsItem(itemSlug);
        this.applyMarketsQuery(route);
        const analysisKey = this.findAnalysisKeyBySlug(
          route.params.analysisType
        );
        if (analysisKey) this.applyAnalysisKey(analysisKey);
      } finally {
        this.isApplyingMarketsRoute = false;
      }
      this.syncMarketsRoute(true);
    },
    buildMarketsRoute() {
      const analysisKey = this.selectedShowView;
      const analysisType = this.analysisSlug(analysisKey);
      if (this.marketsGlobalKeys.indexOf(analysisKey) > -1) {
        return {
          name: "markets-global",
          params: { productType: this.marketsAsset, analysisType },
          query: this.marketsRouteQuery("markets-global")
        };
      }
      return {
        name: "markets-analysis",
        params: {
          productType: this.marketsAsset,
          productItem: this.marketsItemSlug(),
          analysisType
        },
        query: this.marketsRouteQuery("markets-analysis")
      };
    },
    isSameMarketsRoute(routeConfig) {
      if (this.$route.name !== routeConfig.name) return false;
      for (const key of ["productType", "productItem", "analysisType"]) {
        const current = this.$route.params[key] || null;
        const next = routeConfig.params[key] || null;
        if (current !== next) return false;
      }
      const queryKeys = new Set([
        ...Object.keys(this.$route.query || {}),
        ...Object.keys(routeConfig.query || {})
      ]);
      for (const key of queryKeys) {
        const current = this.$route.query[key] || null;
        const next = routeConfig.query[key] || null;
        if (current !== next) return false;
      }
      return true;
    },
    syncMarketsRoute(replace = false) {
      if (this._isDestroyed || this._isBeingDestroyed) return;
      if (this.isApplyingMarketsRoute) return;
      const routeConfig = this.buildMarketsRoute();
      if (
        routeConfig.name === "markets-analysis" &&
        !routeConfig.params.productItem
      ) {
        return;
      }
      if (this.isSameMarketsRoute(routeConfig)) return;
      const navigation = replace
        ? this.$router.replace(routeConfig)
        : this.$router.push(routeConfig);
      navigation.catch(err => {
        if (err && err.name !== "NavigationDuplicated") {
          console.error("Error al actualizar la ruta de markets:", err);
        }
      });
    }
  }
};
